<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <base-alert class="mb-4" />
        <div class="card-outlined p-4">
          <h1 class="text-subtitle-underline">{{ t('account.change_email.title') }}</h1>
          <form @submit.prevent="onSubmit">
            <div class="mb-4">
              <label for="email" class="form-label">{{ t('word.email') }}</label>
              <input
                v-model="email"
                id="email"
                name="email"
                type="email"
                :placeholder="t('word.email')"
                :class="`form-input ${errors['email'] ? '!border-red-500' : ''}`"
              >
              <p class="form-error-text">{{ errors['email'] }}</p>
            </div>
            <div class="flex items-center pt-2">
              <base-form-submit :disabled="btnDisabled" :text="t('word.change')" />
            </div>
          </form>
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { axios } from '@/plugins/axios'
import { ALERT_COLORS } from '@/store/base'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import BaseAlert from '@/components/BaseAlert.vue'

type AccountChangeEmailValues = {
  email: string
}

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BaseFormSubmit,
    BaseAlert
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const initialValues: AccountChangeEmailValues = {
      email: store.state.user.user?.email ?? ''
    }

    const schema = yup.object({
      email: yup.string().required().email().max(255),
    })
    const { handleSubmit, errors } = useForm<AccountChangeEmailValues>({
      validationSchema: schema,
      initialValues
    })
    const { value: email } = useField<string>('email')
    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/confirm-email', values)
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('account.change_email.send_email')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      email,
      onSubmit,
      btnDisabled
    }
  }
})
</script>
